import { type IInternalContactAlliance } from '@inpart-io/padme-iap';
import { type GetterTree } from 'vuex';

import { type IInternalContactAllianceState } from './types';

export const GET_FROM_ALLIANCE = 'getFromAlliance';

const getInternalContactAlliance = (_state: IInternalContactAllianceState, ids = [] as number[]): IInternalContactAlliance[] => {
    return ids
        .map((internalContactAllianceId: number) => {
            return _state.dataObjectList.get(internalContactAllianceId);
        })
        .filter((internalContactAlliance) => {
            return internalContactAlliance;
        });
};

export const getters: GetterTree<IInternalContactAllianceState, unknown> = {
    [GET_FROM_ALLIANCE]: (_state: IInternalContactAllianceState) => {
        return (allianceId: number): IInternalContactAlliance[] | undefined => {
            return getInternalContactAlliance(_state, _state.byAlliance.get(allianceId) ?? []);
        };
    }
};
